import clsx from "clsx";
import { DetailsPanelFieldProps } from "./types";

export const DetailsPanelField = ({
  label,
  children,
  className,
}: DetailsPanelFieldProps) => {
  return (
    <div className={clsx("space-y-1", className)}>
      <div className="text-xs text-gray-500">{label}</div>
      <div className="text-sm text-gray-900">{children}</div>
    </div>
  );
};
